export default __webpack_public_path__ + "9fd4a8bd73f211e0ded32cf4de31b021.webp";